"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneInput = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const input_1 = require("../../input");
const PhoneInput = ({ control, name, label, disabled, }) => {
    const { field } = (0, react_hook_form_1.useController)({ control, name });
    return (react_1.default.createElement(input_1.PhoneInput, { size: input_1.PhoneInput.SIZES.FULL_WIDTH, label: label, disabled: field.disabled || disabled, selfValidate: true, 
        // @ts-expect-error
        innerRef: field.ref, value: field.value, onChange: field.onChange, onBlur: field.onBlur, name: field.name }));
};
exports.PhoneInput = PhoneInput;
